<template>
    <div class="mt-20">
        <el-button
            @click="create"
            type="primary"
            v-if="can(Permissions.CREATE_DD_BACKGROUND)"
            ><i class="mdi mdi-upload-multiple" /> Upload Background
        </el-button>
        <el-table :data="items.data">
            <el-table-column prop="year" label="Month" width="180">
                <template slot-scope="scope">
                    {{ scope.row.name }}
                </template>
            </el-table-column>
            <el-table-column prop="preview" label="Preview" width="180">
                <template slot-scope="{ row }">
                    <img
                        :src="data_get(row, 'preview.url')"
                        alt="Preview"
                        width="100"
                    />
                </template>
            </el-table-column>
            <el-table-column
                prop="actions"
                v-if="
                    can(Permissions.EDIT_DD_BACKGROUND) ||
                    can(Permissions.DELETE_DD_BACKGROUND)
                "
                width="250px"
            >
                <template slot-scope="scope">
                    <el-button-group size="small">
                        <el-button
                            @click="edit(scope.row)"
                            icon="mdi mdi-pencil"
                            v-if="can(Permissions.EDIT_DD_BACKGROUND)"
                            >Edit
                        </el-button>
                        <el-button
                            type="danger"
                            icon="mdi mdi-delete"
                            @click="deleteItem(scope.row)"
                            v-if="can(Permissions.DELETE_DD_BACKGROUND)"
                            :loading="isDeletingItem(scope.row)"
                            >Delete
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :disabled="loading"
            class="mt-10"
            :pagination="items.meta.pagination"
            v-if="items.meta.pagination"
            @current-change="onCurrentChange"
        />
        <el-dialog
            :title="'Upload Background'"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="550px"
        >
            <el-form @submit.prevent="submit()">
                <el-form-item
                    style="max-width: 400px"
                    label="Month"
                    label-width="108px"
                    :class="form.state('month')"
                    v-if="!editItem"
                >
                    <el-select v-model="form.month" placeholder="Select">
                        <el-option
                            v-for="month in months"
                            :key="month.value"
                            :label="month.name"
                            :value="month.value"
                            :disabled="month.disabled"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    :class="form.state('title_color')"
                    class="mb-0"
                    label=" Calendar Title Color"
                >
                    <color-picker
                        :predefine="availableColors"
                        v-model="form.title_color"
                    >
                    </color-picker>
                    <form-feedback :form="form" field="title_color" />
                </el-form-item>
                <el-form-item
                    :class="form.state('background')"
                    label="Upload Image"
                >
                    <input
                        type="file"
                        accept="image/*"
                        @change="
                            (e) => {
                                onChangeFile(e);
                            }
                        "
                    />
                    <form-feedback
                        class="text-small"
                        :form="form"
                        field="background"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" :disabled="form.busy"
                    >Cancel</el-button
                >
                <el-button
                    type="primary"
                    icon="mdi mdi-content-save"
                    @click="submit"
                    :loading="form.busy"
                    >Save
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import unsaved_changes_mixin from "@/mixins/unsaved-changes";
import * as Actions from "@/store/constants/actions";
import auth from "@/mixins/auth";

export default {
    mixins: [unsaved_changes_mixin, auth],
    data() {
        return {
            dialogVisible: false,
            editItem: false,
            editingItem: null,
            items: {
                data: [],
                meta: {
                    pagination: null,
                },
            },
            form: new window.Form({
                name: null,
                month: null,
                title_color: "#000000",
                background: null,
            }),
            loading: false,
            months: [
                {
                    name: "January",
                    value: 1,
                },
                {
                    name: "February",
                    value: 2,
                },
                {
                    name: "March",
                    value: 3,
                },
                {
                    name: "April",
                    value: 4,
                },
                {
                    name: "May",
                    value: 5,
                },
                {
                    name: "June",
                    value: 6,
                },
                {
                    name: " July",
                    value: 7,
                },
                {
                    name: " August",
                    value: 8,
                },
                {
                    name: "September",
                    value: 9,
                },
                {
                    name: "October",
                    value: 10,
                },
                {
                    name: "November",
                    value: 11,
                },
                {
                    name: "December",
                    value: 12,
                },
            ],
            deletingItems: [],
        };
    },
    computed: {
        availableColors() {
            return this.$store.state.config.settings.calendar.title_colors;
        },
    },
    mounted() {
        this.getItems();
        this.form.setVeeErrors(this.veeErrors);
    },
    methods: {
        create() {
            this.dialogVisible = true;
            this.editItem = false;
            this.editingItem = null;
            this.form.clearFields();
        },
        getItems(page = 1) {
            this.loading = true;
            axios
                .get(`/web-api/dd-background?include=preview`, {
                    params: {
                        page,
                    },
                })
                .then((response) => {
                    this.items.data = response.data.data;
                    this.items.meta.pagination = response.data.meta.pagination;
                    for (var i = 0; i < response.data.data.length; i++) {
                        let month = this.months.find(
                            (m) => m.value == response.data.data[i].month
                        );
                        if (month) {
                            month.disabled = true;
                        }
                    }
                })
                .finally(() => (this.loading = false));
        },
        onCurrentChange(e) {
            this.getItems(e);
        },
        onChangeFile(e) {
            this.form.background = e.target.files[0];
        },
        edit(item) {
            this.editItem = true;
            this.editingItem = item;
            this.form.title_color = item.title_color;
            this.dialogVisible = true;
        },
        submit() {
            if (this.editItem) {
                window.App.putData(
                    `/web-api/dd-background/${this.editingItem.id}`,
                    this.form
                ).then((response) => {
                    this.dialogVisible = false;
                    this.getItems();
                    this.$notify.success({
                        message: `Changes have been saved to digital display background.`,
                    });
                });
            } else {
                if (this.form.month) {
                    let month = this.months.find(
                        (m) => m.value == this.form.month
                    );
                    this.form.name = month.name;
                }
                window.App.postData(`/web-api/dd-background`, this.form).then(
                    (response) => {
                        this.dialogVisible = false;
                        this.getItems();
                        this.$notify.success({
                            message: `New Digital Display Background has been saved.`,
                        });
                    }
                );
            }
        },
        isDeletingItem(item) {
            return _.includes(this.deletingItems, item);
        },
        deleteItem(item) {
            this.$confirm("Confirm delete background?", "Confirmation", {
                confirmButtonText: "Delete",
                confirmButtonClass: "el-button--danger",
                cancelButtonText: "Cancel",
                type: "warning",
            })
                .then(() => {
                    axios
                        .delete(`/web-api/dd-background/${item.id}`)
                        .then(() => {
                            window.Utils.arrayDelete(this.items.data, item);
                            this.$notify.success({
                                message: `Digital Display Background ${item.name} has been deleted.`,
                            });
                        })
                        .catch(() => {
                            this.$notify.error({
                                message: `Cannot delete digital display background ${item.name}.`,
                            });
                        })
                        .finally(() => {
                            window.Utils.arrayDelete(this.deletingItems, item);
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style scoped></style>
